import { jsx as _jsx } from "react/jsx-runtime";
import { imagePlaceholder } from "../../../helpers/placeholders";
import { useEditor } from "../../../hooks/EditorProvider";
const tailwindToPx = (value) => {
    if (!value)
        return null;
    return {
        "1": "4",
        "2": "8",
        "3": "12",
        "4": "16",
        "5": "20",
        "6": "24",
        "7": "28",
        "8": "32",
        "9": "36",
        "10": "40",
        "11": "44",
        "12": "48",
        "14": "56",
        "16": "64",
        "20": "80",
        "24": "96",
        "28": "112",
        "32": "128",
        "36": "144",
        "40": "160",
        "44": "176",
        "48": "192",
        "52": "208",
        "56": "224",
        "60": "240",
        "64": "256",
        "72": "288",
        "80": "320",
        "96": "384",
    }[value];
};
const DraggableImage = ({ item: { props, id }, ...rest }) => {
    const { mode } = useEditor();
    const className = props?.className || "h-44 w-44";
    const src = props?.image?.src || imagePlaceholder.src;
    const srcLoader = () => {
        if (!src.includes("cloudfront"))
            return src;
        const findStylingWidth = className.split(" ").find((c) => c.includes("w-"));
        const stylingWidth = findStylingWidth?.split("-")[1] || null;
        const imageWidth = tailwindToPx(stylingWidth);
        if (imageWidth && mode === "production")
            return `${src}?format=webp&width=${parseFloat(imageWidth) * 2}`;
        return `${src}?format=webp`;
    };
    return (_jsx("img", { src: srcLoader(), className: className, alt: props?.image?.src || imagePlaceholder.alt, "editor-img-file": props?.image?.file || imagePlaceholder.file, "editor-key": id, ...rest }));
};
export default DraggableImage;
//# sourceMappingURL=DraggableImage.js.map